import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

// Helper function to stringify query parameters
const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Get Water Use Status List with Query (for remote operations)
export const getWaterUseStatusListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WATER_USE_STATUSES}?${stringifyParams(
			params
		)}`
	);
};

// Get Water Use Status List with Query
export const getWaterUseStatusList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
        // populate: ['creation_user', 'modification_user'],
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['name:asc'],
		...params,
	};

	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WATER_USE_STATUSES}?${stringifyParams(
			queryParams
		)}`
	);
};

// Get Single Water Use Status
export const getWaterUseStatus = water_use_status_id => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_WATER_USE_STATUS}${water_use_status_id}`
	);
};

// Add New Water Use Status
export const addNewWaterUseStatusApi = water_use_status => {
	return apiClient.create(
		`${WATER_RIGHTS_BASE}${url.POST_WATER_USE_STATUS}`,
		water_use_status
	);
};

// Update Water Use Status
export const updateWaterUseStatusApi = water_use_status => {
	return apiClient.put(
		`${WATER_RIGHTS_BASE}${url.PUT_WATER_USE_STATUS}${water_use_status._id}`,
		water_use_status
	);
};

// Delete Water Use Status
export const deleteWaterUseStatusApi = water_use_status_id => {
	return apiClient.delete(
		`${WATER_RIGHTS_BASE}${url.DELETE_WATER_USE_STATUS}${water_use_status_id}`
	);
};

// Check if Water Use Status Exists
export const checkWaterUseStatusExistsApi = name => {
	const queryParams = {
		filters: {
			name: {
				$eq: name,
			},
		},
		fields: ['_id'],
		pagination: {
			page: 1,
			pageSize: 1,
		},
	};

	return apiClient
		.get(
			`${WATER_RIGHTS_BASE}${
				url.CHECK_WATER_USE_STATUS_EXISTS
			}?${stringifyParams(queryParams)}`
		)
		.then(response => {
			return { exists: response && response.length > 0 };
		})
		.catch(() => {
			return { exists: false };
		});
};
